import React, { Component } from "react";

class ChatWidget extends Component {
  state = {
    message: ""
  };

  onChange = (event) => {
    this.setState({ message: event.target.value });
  };

  send = (event) => {
    event.preventDefault();
    if (!this.state.message.trim()) {
      return;
    }
    this.props.onSendMessage(this.state.message);
    this.setState({ message: "" });
  };

  render() {
    return (
      <section className="account">
        <article className="account-information">
          <h5>AI Assistant</h5>
          <p style={{ opacity: 0.8, marginBottom: "0.5rem" }}>
            Lab stub: students will harden this agent and add confirmation controls.
          </p>
        </article>
        <article className="transactions">
          <ul style={{ listStyle: "none", padding: 0, margin: 0, maxHeight: "200px", overflowY: "auto" }}>
            {this.props.chatMessages.length <= 0 ? (
              <li>No messages yet</li>
            ) : (
              this.props.chatMessages.map((item, index) => (
                <li key={index} style={{ marginBottom: "0.4rem" }}>
                  <strong>{item.role}:</strong> {item.content}
                </li>
              ))
            )}
          </ul>
        </article>
        <article>
          <form onSubmit={this.send}>
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                placeholder="Ask about your account, transactions, transfers..."
                value={this.state.message}
                onChange={this.onChange}
              />
            </div>
            <button type="submit" className="btn btn-outline-info">
              Send to AI
            </button>
          </form>
        </article>
      </section>
    );
  }
}

export default ChatWidget;
